module.exports = __webpack_public_path__ + "img/map-nsw.299ec94a.png";